import type { Module } from 'vuex';
import { IndicatorSet } from '@/types/IndicatorSet';
import {RootState} from "@/store";

export interface IndicatorSetsState {
  indicatorSets: IndicatorSet[];
}

const indicatorSetsModule: Module<IndicatorSetsState, RootState> = {
  namespaced: true,
  state: () => ({
    indicatorSets: [],
  }),
  getters: {
    getById: (state) => (idIndicatorSet: number): IndicatorSet | undefined => {
      return state.indicatorSets.find(indicatorSet => indicatorSet.idIndicatorSet === idIndicatorSet);
    },
    getAll: (state): IndicatorSet[] => {
      return state.indicatorSets;
    },
  },
  mutations: {
    setIndicatorSets(state, payload: { indicatorSets: Record<number, any> | any[] }) {
      state.indicatorSets = Object
        .values(payload.indicatorSets)
        .map(raw => IndicatorSet.fromRaw(raw));
    },
    addIndicatorSet(state, payload: any) {
      state.indicatorSets.push(IndicatorSet.fromRaw(payload));
    },
    updateIndicatorSet(state, payload: any) {
      const idx = state.indicatorSets.findIndex(indicatorSet => indicatorSet.idIndicatorSet === payload.idIndicatorSet);
      if (idx !== -1) {
        state.indicatorSets[idx] = IndicatorSet.fromRaw(payload);
      }
    },
    deleteIndicatorSet(state, payload: { idIndicatorSet: number }) {
      state.indicatorSets = state.indicatorSets.filter(indicatorSet => indicatorSet.idIndicatorSet !== payload.idIndicatorSet);
    },
    lockIndicatorSet(state, payload: { idIndicatorSet: number }) {
      const indicatorSet = state.indicatorSets.find(indicatorSet => indicatorSet.idIndicatorSet === payload.idIndicatorSet);
      if (indicatorSet) indicatorSet.locked = true;
    },

    unlockIndicatorSet(state, payload: { idIndicatorSet: number }) {
      const indicatorSet = state.indicatorSets.find(indicatorSet => indicatorSet.idIndicatorSet === payload.idIndicatorSet);
      if (indicatorSet) indicatorSet.locked = false;
    },
  },
  actions: {
    wsSetIndicatorSets({ commit }, payload) {
      commit('setIndicatorSets', payload);
    },
    wsIndicatorSetCreate({ commit }, payload) {
      commit('addIndicatorSet', payload);
    },
    wsIndicatorSetUpdate({ commit }, payload) {
      commit('updateIndicatorSet', payload);
    },
    wsIndicatorSetDelete({ commit }, payload) {
      commit('deleteIndicatorSet', payload);
    },
    wsIndicatorSetLock({ commit }, payload) {
      commit('lockIndicatorSet', payload);
    },
    wsIndicatorSetUnlock({ commit }, payload) {
      commit('unlockIndicatorSet', payload);
    },
  },
};

export default indicatorSetsModule; 